<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="tasks.icon" class="mr-1"></i>
                        <span>{{ tasks.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="name" :debounce="tasks.debounce"
                                            placeholder="Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!name"
                                                @click="name = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="Enabled?" label-for="enabled" label-cols="12">
                                    <treeselect instanceId="enabled" type="number" v-model="enabled" :clearable="true"
                                        :options="enabled_options"></treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Category" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="category" :debounce="tasks.debounce"
                                            placeholder="Category"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!category"
                                                @click="category = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>

                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="tasks" :icon="tasks.icon" :busy="tasks.busy"
                        :toolbarlibrary="tasks.toolbarlibrary" :tools="tasks.tools" :badges="tasks.badges"
                        :fields="tasks.fields" :items="tasks.items" :limit="tasks.limit" :downloaded="tasks.downloaded"
                        :showpages="true" :offset="tasks.offset" :page="tasks.page" @load="tasks_load"
                        @click="tasks_click" @changed="tasks_click('save', $event)" @select="tasks_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="tasks.selected"
                    :config="tasks.action ? { action: tasks.action } : {}" @discard="tasks_click('discard')"
                    @go="tasks_click('go')"></component>
            </div>
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import Setup_TasksAtEdit from "./Components/Setup_TasksAtEdit";

export default {
    name: "Setup_TasksAt",
    components: { Setup_TasksAtEdit },
    watch: {
        async name() {
            await this.tasks_load(0);
        },
        async enabled() {
            await this.tasks_load(0);
        },
        async category() {
            await this.tasks_load(0);
        },
        // "window.width": {
        //     immediate: true,
        //     async handler(newVal, oldVal) {

        //         let state = this.tasks;

        //         // HIDE COLUMNS BELOW WIDTH
        //         if (newVal < 1500) {
        //             // state.fields[7].class = "d-none"
        //             // state.fields[7].class = "d-none"
        //         } else {
        //             // state.fields[7].class = "text-center"
        //             // state.fields[7].class = "text-center"
        //         }
        //         if (newVal < 1800) {
        //             state.fields[10].class = "d-none"
        //         } else {
        //             state.fields[10].class = "text-center"

        //         }
        //     },
        // },
    },
    data() {
        return {
            name: null,
            category: null,
            enabled: null,
            enabled_options: [
                {
                    id: "1",
                    label: "Yes",
                },
                {
                    id: "0",
                    label: "No",
                },
            ],

            tasks: {
                title: "Tasks",
                icon: "fa fa-clock-o",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                action: null,
                tools: "go,filter,download,clipboard,add,copy,edit,deleteconfirm,execute",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-play text-primary",
                        position: "toolbar,actions",
                        disabled: true,
                        action: "execute",
                        label: "Execute",
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-stop text-danger",
                        position: "toolbar,actions",
                        disabled: true,
                        action: "stop",
                        label: "Stop",
                    },
                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "running",
                        label: "State",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "name",
                        label: "Name",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "frequency",
                        label: "Frequency",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "days",
                        label: "Operates",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "at",
                        label: "At",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    // {
                    //     key: "end_at",
                    //     label: "End At",
                    //     class: "d-none d-sm-table-cell",
                    //     sortable: true,
                    //     formatter: (value, key, item) => {
                    //         let result = "";
                    //         if (value) {
                    //             result = this.$moment.unix(value / 1000).format("YYYY-MM-DD HH:mm");
                    //         } else {
                    //             result = 'Never'
                    //         }
                    //         return result;
                    //     },
                    // },

                    //     formatter: (value, key, item) => {
                    //         let result = "";
                    //         if (value) {
                    //             if (value.includes('1')) {
                    //                 result += " Mo"
                    //             }
                    //             if (value.includes('2')) {
                    //                 result += " Tu"
                    //             }
                    //             if (value.includes('3')) {
                    //                 result += " We"
                    //             }
                    //             if (value.includes('4')) {
                    //                 result += " Th"
                    //             }
                    //             if (value.includes('5')) {
                    //                 result += " Fr"
                    //             }
                    //             if (value.includes('6')) {
                    //                 result += " Sa"
                    //             }
                    //             if (value.includes('0')) {
                    //                 result += " Su"
                    //             }
                    //         }
                    //         return result;
                    //     }
                    // },


                    {
                        key: "repeat",
                        label: "Every",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (parseInt(value) > 0) {
                                return value + " min";
                            } else {
                                return "";
                            }
                        },
                    },
                    // {
                    //     key: "start_at",
                    //     label: "Start At",
                    //     // class: "d-none d-sm-table-cell",
                    //     sortable: true,
                    //     formatter: (value, key, item) => {
                    //         let result = "";
                    //         if (value) {
                    //             result = this.$moment.unix(value / 1000).utc(false).format("YYYY-MM-DD");
                    //         }
                    //         return result;
                    //     },
                    // },


                    // {
                    //     key: "category",
                    //     label: "Category",
                    //     sortable: true,
                    //     sortDirection: "desc",
                    //     type: "text",
                    // },
                    {
                        key: "last_at",
                        label: "Last At",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (value) {
                                result = this.$moment.unix(value / 1000).utc(false).format("DD/MM/YY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "lastmessage",
                        label: "Last Message",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },

                    // {
                    //     key: "request",
                    //     label: "Request",
                    //     sortable: true,
                    //     sortDirection: "desc",
                    //     type: "text",
                    // },
                    {
                        key: "enabled",
                        label: "Enabled",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "frequency",
                        type: "badge",
                        daily: "info",
                        weekday: "purple",
                        monthly: "white",
                    },
                    {
                        key: "enabled",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            if (value == '1') {
                                return "Yes";
                            } else {
                                return "No";
                            }
                        },
                    },
                    {
                        key: "running",
                        type: "badge",
                        Idle: "success",
                        Running: "danger",
                        formatter: (value, key, item) => {
                            if (value == "1") {
                                return "Running";
                            } else if (value == "0") {
                                return "Idle";
                            } else {
                                return "";
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.tasks_load();
    },

    methods: {

        accessdenied() {
            this.tasks.denied = [];
            if (!this.user.permissions.includes("setup_tasksat.admin")) {
                this.tasks.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_tasksat.admin")) {
                this.tasks.denied.push("add");
                this.tasks.denied.push("save");
            }

        },

        async tasks_load(offset, limit, page) {
            let state = this.tasks;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                name: this.name,
                category: this.category,
                enabled: this.enabled,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_tasksat(
                            $limit: Int
                            $offset: Int
                            $name: String
                            $category: String
                            $enabled: String
                        ) {
                            setup_tasksat(
                            limit: $limit
                            offset: $offset
                            name: $name
                            category: $category
                            enabled: $enabled              
                            ) {
                                id
                                code
                                name
                                category
                                start_at
                                end_at
                                days
                                frequency
                                at
                                priority
                                repeat
                                running
                                request
                                last_at
                                lastmessage
                                enabled
                                rows
                                updated_at
                                updated_by
                            }
                        }
                        `,
                    variables,
                });

                // USE LOCAL VARIABLE             

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_tasksat
                } else {
                    state.items = response.data.setup_tasksat;
                }



            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async tasks_click(a, ss) {

            let state = this.tasks;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.tasks_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    state.action = null;
                    this.component = null;
                    await this.tasks_load();
                    break;
                case "add":
                case "edit":
                    this.component = "Setup_TasksAtEdit";
                    break;
                case "copy":
                    state.action = "copy";
                    this.component = "Setup_TasksAtEdit";
                    break;

                case "delete":
                    this.tasks_deleteit(ss);
                    break;

                case "execute":
                    await this.tasks_execute(ss)
                    break;

                case "start":
                    await this.tasks_start(ss)
                    break;

                case "stop":
                    await this.tasks_stop(ss)
                    break;
            }
        },
        async tasks_select(ss, tools) {

            let state = this.tasks;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard", "execute"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["copy", "edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm", "start", "stop"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async tasks_start(ss) {
            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id, request: "start" });
            });

            await this.tasks_saveit(rows);
        },
        async tasks_stop(ss) {
            console.log('tasks_stop', ss)
            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id, request: "stop" });
            });

            await this.tasks_saveit(rows);
        },

        async tasks_saveit(ss) {

            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_tasksat_save(
                            $rows: [setup_tasksat_input]
                        ) {
                            setup_tasksat_save(rows: $rows) {
                                id                             
                            }
                        }
                        `,
                    variables,
                });
            } catch (error) {

            }

            await this.tasks_load();

            this.busy = false;
        },
        async tasks_deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
               mutation setup_tasksat_delete(
                $rows: [setup_tasksat_input]
              ) {
                setup_tasksat_delete(rows: $rows) {
                  id
  
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.tasks_load(0);
        },

        async tasks_execute(ss) {

            let state = this.tasks;
            state.busy = true

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ijk4MDYyNmQwLTJjZGMtMTFlYy1iMDhlLTQ5MGQ4NjQwMGZjMCIsImVtYWlsIjoic2NoZWR1bGVyQHRyYXZlbHBsYWNlcy5jby51ayIsInNlc3Npb24iOiJjNW9rVXB4OVRRIiwiaXBhZGRyZXNzIjoiMC4wLjAuMCIsImlhdCI6MTY0NjgyMDA1MSwiZXhwIjoxNjQ2ODIzNjUxfQ.9ffq6IBwb44t2Y9YV12qTreYRfg4T7VR5XaJg4EJPno",
                v2only: "true",
                rows
            }
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query tasksAt_service($token:String, $rows: [TasksAt_input], $v2only:String) {
                            tasksAt_service(
                            token: $token
                            rows: $rows
                            v2only: $v2only        
                            ) 
                        }
                        `,
                    variables,
                });


            } catch (error) {
                console.log(error);
            }
            state.busy = false

            await this.tasks_load(0);
        }

    },
};
</script>

<style></style>